import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ButtonThemeState } from "app/shared";

@Component({
    selector: "dodo-simkit-dialog",
    templateUrl: "./simkit-dialog.component.html",
    styleUrls: ["./simkit-dialog.component.scss"],
    standalone: false
})
export class SimkitDialogComponent implements OnInit {
	public customerName: string;
	_source = "simkit";
	public buttonTheme = ButtonThemeState.GREEN;

	constructor(
		public dialogRef: MatDialogRef<SimkitDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: string
	) {
	}

	ngOnInit() {}

	public continueClicked() {
		console.log("continue button clicked ...");
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}
}
